import React from 'react';
import Link from 'gatsby-link';

export default class LanguageSwitcher extends React.Component {
    render() {
        const {langs, color='white'} = this.props;
        const nextLang = langs.filter((lang) => !lang.selected)[0];

        return (
            <Link to={nextLang.link} style={{color}}>{nextLang.langKey === 'en' ? 'English' : 'Русский'}</Link>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/components/LanguageSwitcher.js